<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('cashCollectionRestaurantSale.pageTitle') }}</h1>
      <ts-breadcrumb :items="[
        { text: $t('home'), href: '/' },
        {
          text: $t('cashCollectionRestaurantSale.pageTitle'),
          active: true,
        },
      ]" />
    </div>
    <div class="row">
      <div class="col-md-3">
        <ts-card>
          <ts-card-wrapper>
            <ts-loading-banner :loading="loading">
              <form>
                <fieldset>
                  <legend>{{ $t('cashCollectionRestaurantSale.criteria') }}</legend>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('cashCollectionRestaurantSale.date')
                      }}</label>
                      <a-range-picker style="width:100%" v-model="model.date_range" valueFormat="DD-MM-YYYY HH:mm"
                        :show-time="{ format: 'HH:mm' }" format="DD-MM-YYYY HH:mm" />
                      <div class="validate" v-if="errors.has('date_range')">
                        {{ errors.first('date_range') }}
                      </div>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col-md-12">
                      <label>{{ $t('incomeBySale.branch') }}</label>
                      <a-select style="width: 100%; font-size: 15px" mode="multiple" placeholder="All" :filterOption="(input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                        " v-model="model.branch_id" :options="branchList" @change="onChangeBranch"></a-select>
                      <div class="validate" v-if="errors.has('branch_id')">
                        {{ errors.first('branch_id') }}
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>{{ $t('stockInDetail.location') }}</label>

                        <a-select v-model="model.location_id" mode="multiple" :defaultActiveFirstOption="true"
                          showSearch :filterOption="(input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                            " :options="locations" :placeholder="$t('all')" class="ts-w-full"></a-select>
                        <div class="validate" v-if="errors.has('location_id')">
                          {{ errors.first('location_id') }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col-md-12">
                      <label>{{ $t('cashCollectionRestaurantSale.cashier') }}</label>
                      <a-select style="width: 100%; font-size: 15px" :filterOption="(input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                        " v-model="model.cashier_id" :options="cashiers" mode="multiple" :maxTagCount="1"
                        :placeholder="$t('all')"></a-select>
                      <div class="validate" v-if="errors.has('sale_id')">
                        {{ errors.first('sale_id') }}
                      </div>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col-md-12">
                      <label>{{ $t('cashCollectionRestaurantSale.tableNumber') }}</label>
                      <a-select style="width: 100%; font-size: 15px" :filterOption="(input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                        " v-model="model.table_id" :options="tableLists" mode="multiple" :maxTagCount="1"
                        :placeholder="$t('all')" @search="handleSearchTable" :loading="table_loading"></a-select>
                      <div class="validate" v-if="errors.has('table_id')">
                        {{ errors.first('table_id') }}
                      </div>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col-md-12">
                      <label>{{ $t('cashCollectionRestaurantSale.paymentMethod') }}</label>
                      <a-select style="width: 100%; font-size: 15px" :filterOption="(input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                        " v-model="model.payment_methods_id" :options="PaymentMethods" mode="multiple" :maxTagCount="1"
                        :placeholder="$t('all')"></a-select>
                      <div class="validate" v-if="errors.has('sale_id')">
                        {{ errors.first('sale_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group">
                      <div class="col-md-12">
                        <a-radio-group v-model="model.report_template">
                          <a-radio value="a4">A4</a-radio>
                          <a-radio value="receipt">Receipt</a-radio>
                        </a-radio-group>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6 text-right">
                      <!-- <ts-button
                        class="btn-block"
                        outline
                        color="success"
                        @click.prevent="exportExcel"
                        :waiting="exporting"
                        ><i class="fas fa-file-excel"></i>
                        {{ $t('excel') }}</ts-button
                      > -->
                    </div>
                    <div class="col-md-6 text-right">
                      <ts-button class="btn-block" color="primary" @click.prevent="preview" :waiting="waiting"><i
                          class="fas fa-file-pdf text-red"></i>
                        {{ $t('preview') }}</ts-button>
                    </div>
                  </div>
                </fieldset>
              </form>
            </ts-loading-banner>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-md-9">
        <ts-card>
          <ts-card-wrapper>
            <form>
              <fieldset>
                <legend>{{ $t('preview') }}</legend>
                <ts-preview-pdf v-model="waiting" :src="src" />
              </fieldset>
            </form>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import { Errors } from 'form-backend-validation'
import * as FileDownload from 'downloadjs'
import { trim, debounce } from 'lodash'

export default {
  name: 'cashCollectionRestaurantSale',
  data() {
    return {
      loading: false,
      table_loading: false,
      waiting: false,
      exporting: false,
      src: null,
      errors: new Errors(),
      PaymentMethods: [],
      cashiers: [],
      tables: [],
      branchList: [],
      locations: [],
      model: {
        sale_id: [],
        cashier_id: [],
        table_id: [],
        payment_methods_id: [],
        branch_id: undefined,
        location_id: undefined,
        report_template: 'a4',
        date_range: [
          moment().startOf('day').format('DD-MM-YYYY HH:mm'),
          moment().endOf('day').format('DD-MM-YYYY HH:mm')
        ]
      },
    }
  },
  computed: {
    tableLists() {
      return this.tables.map((el) => ({
        value: el.table_id,
        label: el.table_no + (el.guest_level ? ' | ' + el.guest_level.guest_level_name_en : ''),
      }))
    }
  },
  async created() {
    this.autoSelectAssign();
    await this.fetchData();
  },
  methods: {
    ...mapActions('report/finance', ['cashCollectionRestaurantSaleByCashier']),
    handleSearchTable: debounce(async function (value) {
      if (!value) {
        return false
      } else {
        this.table_loading = true
        await this.$store
          .dispatch('report/resource/getTable', {
            searchTableName: value,
          })
          .then((response) => {
            this.tables = response.data
          })
          .catch((error) => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.table_loading = false
          })
      }
    }, 500),
    async fetchData() {
      this.loading = true
      await this.$store
        .dispatch('security/user/getBranchAssigned')
        .then((response) => {
          this.branchList = response.data.map((el) => ({
            value: el.branch_id,
            label: el.branch_name_en,
          }))
        })

      await this.$store
        .dispatch('report/resource/getCashier')
        .then((response) => {
          this.cashiers = response.data.map((el) => ({
            value: el.user_id,
            label: el.name,
          }))
        })
      await this.$store
        .dispatch('report/resource/getTable')
        .then((response) => {
          this.tables = response.data
        })
        .catch((error) => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })

      await this.$store
        .dispatch('report/resource/getPaymentMethod')
        .then((response) => {
          this.PaymentMethods = response.data.map((el) => ({
            value: el.payment_method_id,
            label: el.payment_method,
          }))
        })
        .catch((error) => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async autoSelectAssign() {
      this.model.branch_id = [this.$store.state.authUser.user.default_branch.branch_id]
      await this.onChangeBranch()
      this.model.location_id = [this.$store.state.authUser.user.default_location.location_id]
    },
    onChangeBranch() {
      this.locationLoading = true
      this.locations = []
      this.model.location_id = undefined
      this.$store
        .dispatch('report/resource/getLocation', {
          branch_id: this.model.branch_id,
        })
        .then((response) => {
          this.locations = response.data.map((el) => ({
            value: el.location_id,
            label: el.location_name_en,
          }))
        })
        .finally(() => {
          this.locationLoading = false
        })
    },
    preview() {
      this.waiting = true
      this.src = ''
      this.errors = new Errors()
      this.cashCollectionRestaurantSaleByCashier(this.model)
        .then((response) => {
          this.src = response.url
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    exportExcel() {
      this.exporting = true
      this.errors = new Errors()
      this.$store
        .dispatch('report/finance/cashCollectionRestaurantSaleByCashierExcel', this.model)
        .then((response) => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch((err) => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.exporting = false))
    },
  },
}
</script>
